import React from "react";
import PropTypes from "prop-types";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import classNames from "classnames";

const SearchableText = ({ className, query, text }) => {
    // only allow search queries of at least length 2
    if (isEmpty(query)
        || isEmpty(text)
        || query.length > text.length
        || query.length < 2) {
        return <span className={classNames(className)}>{text}</span>;
    }

    let lowerText = text.toLowerCase();
    let lowerQuery = query.toLowerCase();
    let queryLength = query.length;
    let foundIndices = [];

    let foundIndex = lowerText.indexOf(lowerQuery, 0);
    while (foundIndex != -1) {
        foundIndices.push(foundIndex);
        foundIndex = lowerText.indexOf(lowerQuery, foundIndex + queryLength);
    }

    let tokens = [];
    let currentLocation = 0;
    forEach(foundIndices, i => {
        tokens.push(<span key={currentLocation}>{text.slice(currentLocation, i)}</span>);
        tokens.push(<span key={"match"+i} className="match">{text.slice(i, i + queryLength)}</span>);
        currentLocation = i + queryLength;
    });
    tokens.push(<span key={currentLocation}>{text.slice(currentLocation)}</span>);

    return (
        <span className={classNames("searchable", className)}>
            {tokens.map(t => t)}
        </span>
    );
};

SearchableText.propTypes = {
    query: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string
};

export default SearchableText;
